import React, { useEffect, useState } from 'react'
import { CNav, CNavItem, CNavLink, CCol, CFormLabel, CButton, CCardBody, CCard, CFormInput, CRow, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CHeader } from '@coreui/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import DivLoader from '../../components/shared/DivLoader'
import AssesmentSuggestion from './AssesmentSuggestion'
import ListView from '../../components/shared/ListView'
import SaveExtra from '../../services/general/saveExtraData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'

import GeneralExamination from './GeneralExamination'
import PEAddEditModel from '../../components/shared/PEAddEditModel'
import DiagnosisPhysicalExamination from './DiagnosisPhysicalExamination'
import HierarchyComponent from './HierarchyComponents'

const DiagnosisExaminationView = ({ diagnosisExamination, setShowAddEditPopup, showAddEditPopup, setDiagnosisExamination, handleSubmit, setAddPopup, editModelVisible, setEditModelVisible, selectedExamination, setSelectedExamination }) => {
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [editFormData, setEditFormData] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [currentParentID, setCurrentParentID] = useState(null)
  const [viewData, setViewData] = useState(null)

  // const generateId = () => Math.floor(Math.random() * 1000000);

  // const addIdToHierarchy = (hierarchy) => {
  //     return hierarchy.map(item => ({
  //         ...item,
  //         id: item.id || generateId(),
  //         hierarchy: item.hierarchy ? addIdToHierarchy(item.hierarchy) : []
  //     }));
  // };

  // const addIdToExistingData = (dataArray) => {
  //     return dataArray.map(item => ({
  //         ...item,
  //         id: item.id || generateId(),
  //         hierarchy: item.hierarchy ? addIdToHierarchy(item.hierarchy) : []
  //     }));
  // };

  // const handleSave = (data) => {

  //     const dataWithId = addIdToExistingData([data])[0];

  //     setDiagnosisExamination((prev) => {
  //         let updatedData = !prev || prev.length === 0 ? [dataWithId] : [...prev, dataWithId];
  //         updatedData = addIdToExistingData(updatedData)
  //         setTimeout(() => handleSubmit(updatedData), 1000);
  //         return updatedData;
  //     });
  // };

  const handleEditFunction = (item) => {
    setShowAddEditPopup(true)
    setEditFormData(item)
    setIsEdit(true)
  }

  const handleDisplayData = (item) => {
    setCurrentParentID(item.id)
    setEditModelVisible(true)
    setSelectedExamination(item)
  }

  const handleSave = (data, id = null) => {
    if (isEdit && id) {
      setDiagnosisExamination((prev) => {
        if (!prev || prev.length === 0) return [data]

        const newData = prev.map((item) => (item?.id === id ? { ...item, ...data } : item))

        // handleSubmit(newData)
        return newData
      })
    } else {
      setDiagnosisExamination((prev) => {
        const updatedData = !prev || prev.length === 0 ? [data] : [...prev, data]
        handleSubmit(updatedData)
        return updatedData
      })
    }
    onCloseModule()
  }

  const onCloseModule = () => {
    setShowAddEditPopup(false)
    setEditFormData(null)
    setIsEdit(false)
    setAddPopup(false)
  }

  const handleDeleteData = (ID) => {
    try {
      setDiagnosisExamination((prev) => {
        if (!prev || prev.length === 0) return []

        const newData = prev.filter((item) => item?.id !== ID)
        handleSubmit(newData)
        return newData
      })
      setDeleteVisibleId(null)
    } catch (error) {
      console.log(error)
      toast.error('An error occurred while deleting the diagnosis', toastConfig)
    }
  }

  const closeEditModel = () => {
    setEditModelVisible(false)
    setAddPopup(false)
  }

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('draggedIndex', index)
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDrop = (e, dropIndex) => {
    e.preventDefault()
    const draggedIndex = e.dataTransfer.getData('draggedIndex')

    if (draggedIndex === dropIndex) return

    const updatedItems = [...diagnosisExamination]
    const [movedItem] = updatedItems.splice(draggedIndex, 1)
    updatedItems.splice(dropIndex, 0, movedItem)
    setDiagnosisExamination(updatedItems)
    handleSubmit(updatedItems)
  }

  return (
    <>
      <DivLoader isLoading={isPageLoading}>
        <div>
          <CRow className="p-2">
            {diagnosisExamination?.map((item, index) => {
              try {
                return (
                  <CCol xs={4} key={item.id} draggable onDragStart={(e) => handleDragStart(e, index)} onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, index)} style={{ cursor: 'grab' }}>
                    <ListView
                      heading={item.name}
                      // editFunc={() => handleEditFunction(item)}
                      editFunc={() => handleDisplayData(item)}
                      deletePEFunc={() => setDeleteVisibleId(item?.id)}
                      contentMatch={item?.isHierarchy}
                      viewFunc={() => setViewData(item)}
                      // setting={() => handleDisplayData(item)}
                    />
                  </CCol>
                )
              } catch (error) {
                return (
                  <CCol xs={4} key={index}>
                    <div className="text-danger">An error occurred while processing this diagnosis.</div>
                  </CCol>
                )
              }
            })}
          </CRow>
        </div>

        <CModal backdrop="static" size="xl" visible={editModelVisible} className="custom-modal patient-theme-modal physical-view-theme__modal">
          <CModalBody className="">
            <DiagnosisPhysicalExamination
              selectedExamination={selectedExamination}
              closeEditModel={closeEditModel}
              editFormData={editFormData}
              diagnosisExamination={diagnosisExamination}
              setDiagnosisExamination={setDiagnosisExamination}
              parentId={currentParentID}
              setSelectedExamination={setSelectedExamination}
              handleSubmit={handleSubmit}
              handleEditFunction={handleEditFunction}
            />
          </CModalBody>
        </CModal>

        {/* add edit pop up */}
        <CModal backdrop="static" size="md-auto" visible={showAddEditPopup} onClose={() => onCloseModule()} className="patient-theme-modal physical-view-theme__modal">
          <CModalHeader onClose={() => onCloseModule()}>
            <CModalTitle> {isEdit ? 'Edit' : 'Add'} </CModalTitle>
          </CModalHeader>
          <CModalBody className="">
            <PEAddEditModel
              setShowAddEditPopup={setShowAddEditPopup}
              showAddEditPopup={showAddEditPopup}
              handleSave={handleSave}
              editFormData={editFormData}
              setEditFormData={setEditFormData}
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              onCloseModule={onCloseModule}
              type={'accordion'}
              showCopy={false}
              showType={false}
              showHierarchyType={false}
              useDiagnosisNameSelect
            />
          </CModalBody>
        </CModal>

        {/* delete warning pop up */}
        <CModal backdrop="static" visible={!!deleteVisibleId} onClose={() => setDeleteVisibleId(null)} className="patient-theme-modal physical-view-theme__modal">
          <CModalHeader onClose={() => setDeleteVisibleId(null)}>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              color="secondary"
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="ui-action-btn ui-action-btn--secondary"
            >
              Close
            </CButton>
            <CButton color="danger" onClick={() => handleDeleteData(deleteVisibleId)} className="ui-action-btn ui-action-btn--danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal
          alignment="center"
          aria-labelledby="VerticallyCenteredExample"
          backdrop="static"
          size="xl"
          className="h-100 patient-theme-modal physical-view-theme__modal"
          visible={!!viewData}
          onClose={() => {
            setViewData(null)
          }}
        >
          <CModalHeader onClose={() => setViewData(null)}>
            <strong>{viewData?.name}</strong>
          </CModalHeader>
          {viewData && <HierarchyComponent splitTitle={true} viewData={viewData} />}
          <hr className="p-0" />
          <CModalFooter>
            <CButton color="secondary" className="ui-action-btn ui-action-btn--secondary" onClick={() => setViewData(null)}>
              Close
            </CButton>
          </CModalFooter>
        </CModal>
      </DivLoader>
    </>
  )
}

export default DiagnosisExaminationView
